import React, { useEffect, useState } from "react";
import axios from "axios";
import Constants from "../utils/Constants";
import { formatDate, getTimeDeltaHuman, makeAlphanumeric } from "../utils/Functions";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { Box, Button, Typography, InputLabel, Select, makeStyles } from "@material-ui/core";
import { Stack, MenuItem } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import { ValidatedTextField, anyErrors } from "../utils/ValidatedTextField";
import Listener from "./Listener";
import AddOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import AlertSinkList from "./AlertSiinkList";

const http_str = "https://"
const vpc_base_url = '.console.aws.amazon.com/vpcconsole/home?region='


const useStyles = makeStyles(theme => ({
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        '& .MuiFormLabel-root.Mui-disabled': {
            color: 'red',
        },
        '& .MuiPaper-root': {
            backgroundColor: '#333333',
        }
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#1be01e',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#5861fc',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#fc0d31',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogWidget: {
        margin: '5px',
        color: '#CCCCCC',
        justify: 'flex',
        alignItems: 'center',
    },
    inputRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        verticalAlign: 'baseline',
        '& .MuiSelect-filled': {
            color: 'black',
            backgroundColor: '#555555',
        },
        '& .MuiSelect-iconFilled': {
            color: 'black',
        },
    },
    textField: {
        '&.Mui-disabled': {
          color: 'grey !important',
        },
    },
    accordian: {
        color: '#EEE',
        justifyContent: "unset",
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))


let listener_headers = [
    { field: 'enabled', headerName: 'Enabled', width: 40, hidden: false },
    { field: 'listener_type', headerName: 'Type', width: 100, hidden: false },
    { field: 'target', headerName: 'Target', width: 'auto', hidden: false },
    { field: 'edit', headerName: 'Edit', width: 50, hidden: false },
    { field: 'delete', headerName: 'Delete', width: 50, hidden: false },
]

export default function AnalyzersDialog({ mode, open, onClose, onSave, formData, setFormData, siteData, policyData, analyzerData}) {
    const classes = useStyles()
    const [error, setError] = useState([])
    const [isRequiredFieldEmpty, setIsRequiredFieldEmpty] = useState(false)
    const [requiresSave, setRequiresSave] = useState(false)
    const [accordianOpen, setAccordianOpen] = useState(false)
    const [installTypeDisabled, setInstallTypeDisabled] = useState(false)
    const defaultPlaceholderSubnets = `Subnet IDs\n1 per line\nmax 3`
    const [placeholderSubnets, setPlaceholderSubnets] = useState(defaultPlaceholderSubnets)

    const log_level_menu = ['ERROR', 'WARN']
    let install_type_menu = ['Standalone', 'Distributed']
    let platform_type_menu = ['AWS', 'GCP', 'Linux', 'Synology', 'Windows']
    const size_menu = ['SMALL', 'MEDIUM', 'LARGE']
    let title = 'Analyzers'


    if (mode === 'edit') {
        title = 'Edit Analyzer: ' + formData.pk
        // Check older analyzers which may not have this field
        if (formData.alerts === undefined) {
            formData.alerts = []
            setRequiresSave(true)
        }
        //else {
        //    setRequiresSave(false)
        //}
    }
    else {
        title = 'Add Analyzer'
        //setRequiresSave(true)
    }

    function dynamic_fields() {
        // This is for storage specific fields, i.e. S3 vs SMB
        if (formData.install_type === 'Distributed' && formData.platform !== 'Linux') {
            return (
                <>
                    <Grid item xs={2} className={classes.inputRow}>
                        <InputLabel className={classes.dialog}>Analyzer</InputLabel>
                    </Grid>
                    <Grid item xs={5}>
                        <Select
                            name='analyzer_name'
                            label='Analyzer'
                            value={formData.analyzer_name}
                            onChange={handleChange}
                            variant={"outlined"}
                            classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                              style={{minWidth: 200}}
                        >
                            <MenuItem key={0} value={'not assigned'}>not assigned</MenuItem>
                            {analyzerData.map((item) =>
                                <MenuItem key={item} value={item.pk}>{item.pk}</MenuItem>)}
                        </Select>
                    </Grid>
                </>
            )
        }
    }

    const toggleEnvironmentAccordian = () => {
        setAccordianOpen(! accordianOpen)
    };

    function environment_fields(platform) {
        // This is for storage specific fields, i.e. S3 vs SMB
        //console.log("set dynamic fields based on OS: " + platform)
        if (platform === 'AWS') {
            return (
                <>
                    <Accordion className={classes.accordian} expanded={accordianOpen} onChange={toggleEnvironmentAccordian}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                          sx={{
                                bgColor: "#555555"
                            }}
                        >
                        Amazon Web Services*
                        </AccordionSummary>
                        <AccordionDetails className={classes.dialog}>
                            <Grid container spacing={2}>
                                <Grid item xs={2} className={classes.inputRow}>
                                    <InputLabel className={classes.dialog}>Region</InputLabel>
                                </Grid>
                                <Grid item xs={7}>
                                    <ValidatedTextField
                                        id='cloud_region'
                                        name='cloud_region'
                                        label='Region*'
                                        value={formData.cloud_region}
                                        onChange={handleChange}
                                        variant={"outlined"}
                                        classes={{ root: classes.whiteColor }}
                                        sx={{ width: 350 }}
                                        inputProps={{ style: { color: "#FFF" } }}
                                        InputLabelProps={{ style: { color: "#AAA" } }}
                                        error={error}
                                        setError={setError}
                                        mode='aws-region'
                                        required={formData.storage_type === 'S3' ? 'required': null}
                                        maxLength={16}
                                    />
                                </Grid>
                                <Grid item xs={3} className={classes.inputRow}>
                                </Grid>
                                <Grid item xs={2} className={classes.inputRow}>
                                    <InputLabel className={classes.dialog}>SQS Queue:</InputLabel>
                                </Grid>
                                <Grid item xs={10} className={classes.inputRow}>
                                    <ValidatedTextField
                                        fullWidth
                                        name='sqs_queue'
                                        label='Name*'
                                        value={formData.sqs_queue}
                                        onChange={handleChange}
                                        variant={"outlined"}
                                        classes={{root: classes.whiteColor}}
                                        sx={{ width: 350 }}
                                        inputProps={{ style: { color: "#FFF" } }}
                                        InputLabelProps={{ style: { color: "#AAA" } }}
                                        error={error}
                                        setError={setError}
                                        maxLength={64}
                                        mode='default'
                                        required={formData.storage_type === 'S3' ? 'required': null}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <InputLabel className={classes.dialogWidget}>VPC</InputLabel>
                                </Grid>
                                <Grid item xs={8}>
                                    <ValidatedTextField
                                        fullWidth
                                        name='vpc_id'
                                        label='VPC ID*'
                                        value={formData.vpc_id}
                                        onChange={handleChange}
                                        variant={"outlined"}
                                        //className={classes.dialog}
                                        classes={{ root: classes.whiteColor }}
                                        sx={{ width: 350 }}
                                        inputProps={{ style: { color: "#FFF" } }}
                                        InputLabelProps={{ style: { color: "#AAA" } }}
                                        error={error}
                                        setError={setError}
                                        mode='aws-vpc-id'
                                        required={formData.storage_type === 'S3' ? 'required': null}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <CloudOutlinedIcon color={formData.cloud_region && formData.site_uuid !== '' ? "primary" : "error"} onClick={event => window.open(getVpcUrl('vpc'), '_blank')} />
                                </Grid>
                                <Grid item xs={2}>
                                    <InputLabel className={classes.dialogWidget}>Subnets</InputLabel>
                                </Grid>
                                <Grid item xs={8}>
                                    <ValidatedTextField
                                        fullWidth
                                        multiline
                                        maxRows={3}
                                        name='subnets'
                                        label='Subnet IDs*'
                                        placeholder={placeholderSubnets}
                                        value={formData.subnets?.join("\n")}
                                        onChange={handleChange}
                                        variant={"outlined"}
                                        classes={{ root: classes.whiteColor }}
                                        sx={{ width: 350 }}
                                        inputProps={{ style: { color: "#FFF" } }}
                                        InputLabelProps={{ style: { color: "#AAA" } }}
                                        error={error}
                                        setError={setError}
                                        mode='aws-subnet-id'
                                        required={formData.storage_type === 'S3' ? 'required': null}
                                        maxLength={80}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <CloudOutlinedIcon color={formData.cloud_region && formData.site_uuid !== '' ? "primary" : "error"} onClick={event => window.open(getVpcUrl('subnet'), '_blank')} />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </>
            )
        }
        else if (platform === 'GCP') {
            return (
                <>
                    <Accordion className={classes.accordian} expanded={accordianOpen} onChange={toggleEnvironmentAccordian}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                          // expanded={accordianOpen.toString()}
                          sx={{
                                bgColor: "#555555"
                            }}
                        >
                        Google Cloud Platform*
                        </AccordionSummary>
                        <AccordionDetails className={classes.dialog}>
                            <Grid container spacing={2}>
                                <Grid item xs={11}>
                                    <div style={{
                                            width: '400px',
                                            height: 0,
                                            visibility: 'hidden',
                                            overflow: 'hidden',
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} className={classes.inputRow}>
                                    <InputLabel className={classes.dialog}>Region</InputLabel>
                                </Grid>
                                <Grid item xs={8}>
                                    <ValidatedTextField
                                        id='cloud_region'
                                        name='cloud_region'
                                        label='Region*'
                                        value={formData.cloud_region}
                                        onChange={handleChange}
                                        variant={"outlined"}
                                        classes={{ root: classes.whiteColor }}
                                        sx={{ width: 350 }}
                                        inputProps={{ style: { color: "#FFF" } }}
                                        InputLabelProps={{ style: { color: "#AAA" } }}
                                        error={error}
                                        setError={setError}
                                        mode='gcp-region'
                                        required={formData.storage_type === 'GCP' ? 'required': null}
                                        maxLength={16}
                                    />
                                </Grid>
                                <Grid item xs={2} className={classes.inputRow}>
                                    <InputLabel className={classes.dialog}></InputLabel>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </>
            )
        }
        else if (platform === 'Linux') {
            return (
                <>
                    <Accordion className={classes.accordian} expanded={accordianOpen} onChange={toggleEnvironmentAccordian}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                          // expanded={accordianOpen.toString()}
                          sx={{
                                bgColor: "#555555"
                            }}
                        >
                        Inputs*
                        </AccordionSummary>
                        <AccordionDetails className={classes.dialog}>
                            <Stack direction={"row"} justifyContent={"flex-end"}>
                                <Box>
                                    <AddOutlinedIcon className={classes.spaced} color={"primary"}
                                         onClick={() => handleAddListener()}/>
                                </Box>
                            </Stack>
                            <Grid container spacing={2}>
                                <Grid item xs={9}>
                                    <div style={{
                                            width: '400px',
                                            height: 0,
                                            visibility: 'hidden',
                                            overflow: 'hidden',
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} className={classes.inputRow}>
                                {/* TABLE */}
                                <table className={classes.tableComponent} style={{width: 100 + "%"}}>
                                    <thead>
                                    <tr key={1} className={classes.tableComponent}>
                                        {listener_headers.map((header, index) => (
                                            <th key={index} width={header.width}
                                                className={header.hidden === true ? classes.hide : ''}>{header.headerName}</th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody className={classes.tableComponent}>
                                    {formData.listeners && formData.listeners.map((val, index) =>
                                        <Listener key={index} index={index} listener={val} headers={listener_headers} handleListenerChange={handleListenerChange} handleListenerDelete={handleListenerDelete} setRequiresSave={setRequiresSave} />
                                    )}
                                    </tbody>
                                </table>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </>
            )
        }
    }

    function alerting_section() {
        // This is for alert specific fields, e.g SNS, SecurityHub, SIEM etc
        return (
            <>
                <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3-content"
                      id="panel3-header"
                    >
                    Alert Notifications
                    </AccordionSummary>
                    <AccordionDetails className={classes.dialog}>
                        <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>
                            Alerts can be set here globally, or can be set at the Site or Analyzer levels.
                        </Typography>
                        <AlertSinkList
                            parent={formData.pk}
                            alert_source="analyzer"
                            alerts={formData.alerts}
                            handleAlertAdd={handleAlertAdd}
                            handleAlertChange={handleAlertChange}
                            handleAlertInternalChange={handleAlertInternalChange}
                            handleAlertDelete={handleAlertDelete}
                            requiresSave={requiresSave}
                            setRequiresSave={setRequiresSave}
                        />
                    </AccordionDetails>
                </Accordion>
            </>
        )
    }

    const getVpcUrl = (type) => {
        return http_str.concat(formData.cloud_region, vpc_base_url, formData.cloud_region, '#', type, 's:')
    }

    const updateSnsArn = (region, account, pk) => {
        const base = 'arn:aws:sns:'
        let arn = base.concat(region, ':', account, ':' + Constants.applicationName.toLowerCase() + '-', region, '-', pk, '-alerts')
        setFormData((prevFormData) => ({...prevFormData, ['sns_topic_arn']: arn}))
    }

    const updateSqs = (region, account, pk) => {
        let sqs = Constants.applicationName.toLowerCase() + '-' + region + '-' + pk + '-queue'
        setFormData((prevFormData) => ({...prevFormData, ['sqs_queue']: sqs}))
    }

    const updateSuspendPolicyArn = (account) => {
        let suspend = 'arn:aws:iam::' + account + ':policy/RansomStopSuspendUserAccountAWS'
        setFormData((prevFormData) => ({...prevFormData, ['suspend_user_policy']: suspend}))
    }

    const handleChange = (event) => {
        const {name, value} = event.target
        console.log("handleChange: " + name + ": " + value)
        if (name === 'pk') {
            setFormData((prevFormData) => ({...prevFormData, [name]: makeAlphanumeric(value)}))
        }
        else if (name === 'subnets') {
            setFormData((prevFormData) => ({ ...prevFormData, [name]: value.split('\n') }))
        }
        else if (name === 'cloud_region') {
            if (formData['storage_type'] === 'S3') {
                setFormData((prevFormData) => ({...prevFormData, [name]: value}))
                updateSqs(value, formData.aws_account_id, formData.pk)
                updateSnsArn(value, formData.aws_account_id, formData.pk)
            }
            else {
                setFormData((prevFormData) => ({...prevFormData, [name]: value}))
            }
        }
        else if (name === 'site_uuid') {
            siteData.forEach((element, index, array) => {
                if (element.pk === value) {
                    setFormData((prevFormData) => ({...prevFormData, ['site_uuid']: element.pk}))
                    setFormData((prevFormData) => ({...prevFormData, ['site_name']: element.site_name}))
                    setFormData((prevFormData) => ({...prevFormData, ['aws_account_id']: element.aws_account_id}))
                    updateSnsArn(formData.cloud_region, element.aws_account_id, formData.pk)
                    updateSuspendPolicyArn(element.aws_account_id)
                }
            })
        }
        else if (name === 'subnets') {
            if (value === '') {
                setPlaceholderSubnets(defaultPlaceholderSubnets)
            } 
            else {
                setPlaceholderSubnets('');
            }

        }
        else {
            setFormData((prevFormData) => ({...prevFormData, [name]: value}))
        }
        setRequiresSave(true)
	};

    const handleCheckboxChange = (event) => {
        const {name, value} = event.target
        console.log("handleCheckboxChange: " + name + ": " + value)
        setRequiresSave(true)
        setFormData((prevFormData) => ({...prevFormData, [name]: event.target.checked}))
	};

    const handleAlertChange = (index, event) => {
        let {name, value} = event.target
        console.log("alert index: " + index)
        console.log("handleAlertChange: " + name + ": " + value)
        const items_length = formData.alerts.length;
        if (index >= 0  && index < items_length) {
            // convert comma-seperated list into array
            if (name === 'recipients') {
                value = value.split(",")
            }
            setFormData((prevFormData) => {
                const newItems = [...prevFormData.alerts];
                let newItem = {...newItems[index]};
                newItem = {...newItem, [name]: value};
                if (newItem.alert_type === "AWS SNS") {
                    newItem.internal = true
                } else if (newItem.alert_type === "Email") {
                    newItem.internal = false
                } else if (newItem.alert_type === "Slack") {
                    newItem.internal = false
                }
                newItems[index] = newItem;
                console.log("newItem: " + JSON.stringify(newItem));
                return {...prevFormData, alerts: newItems}
            })
        }
        setRequiresSave(true)
    };

    const handleAlertInternalChange = (index, event) => {
        let checked = event.target.checked
        console.log("alert index: " + index)
        console.log("handleAlertInternalChange: " + checked)
        const items_length = formData.alerts.length;
        if (index >= 0  && index < items_length) {
            setFormData((prevFormData) => {
                const newItems = [...prevFormData.alerts];
                let newItem = {...newItems[index]};
                if (newItem.alert_type === "Email") {
                    newItem.internal = false
                } else if (newItem.alert_type === "Slack") {
                    newItem.internal = false
                }
                else {
                    newItem = {...newItem, "internal": checked};
                }
                newItems[index] = newItem;
                console.log("newItem: " + JSON.stringify(newItem));
                return {...prevFormData, alerts: newItems}
            })
        }
        setRequiresSave(true)
    };

    const handleAlertDelete = (index) => {
        console.log("handleAlertDelete: " + index)
        const items_length = formData.alerts.length;
        if (index >= 0  && index < items_length) {
            setFormData((prevFormData) => {
                let newItems = [...prevFormData.alerts];
                newItems.splice(index, 1);
                console.log("newItem: " + JSON.stringify(newItems));
                return {...prevFormData, alerts: newItems}
            })
        }
        setRequiresSave(true)
    };

    const handleAlertAdd = () => {
        console.log("got AddAlert event")
        setFormData((prevFormData) => {
            let newItems = [...prevFormData.alerts];
            const new_alert = {"alert_type": "", "enabled": false, "inherited": false, "inherited_from": "", "internal": false}
            newItems.unshift(new_alert)
            return {...prevFormData, alerts: newItems}
        })
        setRequiresSave(true)
    }

    const handleListenerChange = (index, event) => {
        let {name, value} = event.target
        console.log("listener index: " + index)
        console.log("handleListenerChange: " + name + ": " + value)
        const items_length = formData.listeners.length;
        if (index >= 0  && index < items_length) {
            setFormData((prevFormData) => {
                setRequiresSave(true)
                const newItems = [...prevFormData.listeners];
                let newItem = {...newItems[index]};
                newItem = {...newItem, [name]: value};
                newItems[index] = newItem;
                console.log("newItem: " + JSON.stringify(newItem));
                return {...prevFormData, listeners: newItems}
            })
        }

    };

    const handleListenerDelete = (index) => {
        console.log("handleListenerDelete: " + index)
        const items_length = formData.listeners.length;
        if (index >= 0  && index < items_length) {
            setFormData((prevFormData) => {
                let newItems = [...prevFormData.listeners];
                newItems.splice(index, 1);
                console.log("newItem: " + JSON.stringify(newItems));
                return {...prevFormData, listeners: newItems}
            })
        }
        setRequiresSave(true)
    };

    const handleAddListener = () => {
        console.log("got Add Listener event")
        // check for listeners, old versions may not have this
        if (! formData['listeners']) {
            setFormData((prevFormData) => {
                return {...prevFormData, listeners: []}
            })
        }
        setFormData((prevFormData) => {
            let newItems = [...prevFormData.listeners];
            const new_item = {"listener_type": "HTTP", "enabled": true}
            newItems.unshift(new_item)
            return {...prevFormData, listeners: newItems}
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        onSave(formData)
    }

    const getSaveButtonDisabled = () => {
        // returns True if Save should be disabled and False if it should be enabled
        if (anyErrors(error) !== undefined && error.length > 0) {
            console.log("input errors: " + JSON.stringify(error))
            return true
        }
        else if (isRequiredFieldEmpty) {
            console.log("required field empty")
            return true
        }
        else if (!requiresSave) {
            // console.log("no changes found to save")
            return true
        }
        else {
            // console.log("save button is enabled")
            return false
        }
    }

    useEffect(() => {
        if ( (formData.platform === 'AWS') && (
            formData.pk.trim() === '' ||
            formData.site_uuid.trim() === '' ||
            formData.policy_uuid.trim() === '' ||
            formData.cloud_region.trim() === '' ||
            formData.sqs_queue.trim() === '' ||
            formData.vpc_id.trim() === '' ||
            formData.subnets.length === 0 ) ) {
                console.log("required field (pk): " + formData.pk.trim())
                console.log("required field: " + formData.site_uuid.trim())
                console.log("required field: " + formData.policy_uuid.trim())
                console.log("required field: " + formData.cloud_region.trim())
                console.log("required field (sqs_queue): " + formData.sqs_queue.trim())
                console.log("required field: " + formData.vpc_id.trim())
                console.log("required field: " + formData.subnets.length)
                setIsRequiredFieldEmpty(true)
        } else if ( (formData.platform === 'Windows') && (
            formData.pk.trim() === '' ||
            formData.site_uuid.trim() === '' ||
            formData.policy_uuid.trim() === '') ) {
                console.log("required field (pk): " + formData.pk.trim())
                console.log("required field (site_uuid): " + formData.site_uuid.trim())
                console.log("required field (policy_uuid): " + formData.policy_uuid.trim())
                setIsRequiredFieldEmpty(true)
        } else if ( (formData.platform === 'GCP') && (
            formData.pk.trim() === '' ||
            formData.site_uuid.trim() === '' ||
            formData.policy_uuid.trim() === '' ||
            formData.cloud_region.trim() === '' ) ) {
                console.log("required field: " + formData.pk.trim())
                console.log("required field: " + formData.site_uuid.trim())
                console.log("required field: " + formData.policy_uuid.trim())
                console.log("required field: " + formData.cloud_region.trim())
                setIsRequiredFieldEmpty(true)
        } else if ( (formData.platform === 'Synology') && (
            formData.pk.trim() === '' ||
            formData.site_uuid.trim() === '' ||
            formData.policy_uuid.trim() === '') ) {
                setIsRequiredFieldEmpty(true)
        }
        setIsRequiredFieldEmpty(false)
        
    }, [
        formData.pk,
        formData.analyzer_name,
        formData.install_type,
        formData.node_type,
        formData.platform,
        formData.site_uuid,
        formData.policy_uuid,
        formData.sqs_queue,
        formData.aws_account_id,
        formData.cloud_region,
        formData.vpc_id,
        formData.subnets,
        formData.storage_type,
        formData.log_level,
        formData.log_interval,
        formData.listeners
    ])

    useEffect(() => {
        if (formData.platform === 'AWS') {
                setIsRequiredFieldEmpty(true)
                setFormData((prevFormData) => ({...prevFormData, 'storage_type': 'S3'}))
                setFormData((prevFormData) => ({...prevFormData, 'install_type': 'Standalone'}))
                setInstallTypeDisabled(true)
                setFormData((prevFormData) => ({...prevFormData, 'node_type': 'Standalone'}))
                setAccordianOpen(true)
        } else if (formData.platform === 'Windows') {
                setIsRequiredFieldEmpty(true)
                setInstallTypeDisabled(false)
                setFormData((prevFormData) => ({...prevFormData, 'storage_type': 'SMB'}))
            if (formData.install_type === 'Standalone') {
                setFormData((prevFormData) => ({...prevFormData, 'node_type': 'Standalone'}))
            }
            else if (formData.install_type === 'Distributed') {
                setFormData((prevFormData) => ({...prevFormData, 'node_type': 'Listener'}))
            }
        } else if (formData.platform === 'Linux') {
                setIsRequiredFieldEmpty(true)
                setFormData((prevFormData) => ({...prevFormData, 'storage_type': ''}))
                setFormData((prevFormData) => ({...prevFormData, 'install_type': 'Distributed'}))
                setInstallTypeDisabled(true)
                setFormData((prevFormData) => ({...prevFormData, 'node_type': 'Analyzer'}))

        } else if (formData.platform === 'GCP') {
                setIsRequiredFieldEmpty(true)
                setFormData((prevFormData) => ({...prevFormData, 'storage_type': 'GDrive'}))
                setFormData((prevFormData) => ({...prevFormData, 'install_type': 'Standalone'}))
                setInstallTypeDisabled(true)
                setFormData((prevFormData) => ({...prevFormData, 'node_type': 'All'}))
                setAccordianOpen(true)
        } else if (formData.platform === 'Synology') {
                setIsRequiredFieldEmpty(true)
                setFormData((prevFormData) => ({...prevFormData, 'storage_type': 'Synology'}))
                setFormData((prevFormData) => ({...prevFormData, 'install_type': 'Distributed'}))
                setInstallTypeDisabled(true)
                setFormData((prevFormData) => ({...prevFormData, 'node_type': 'Responder'}))
        }
        setIsRequiredFieldEmpty(false)


    }, [
        formData.pk,
        formData.platform,
        formData.install_type,
        formData.site_uuid,
        formData.policy_uuid,
        formData.sqs_queue,
        formData.aws_account_id,
        formData.cloud_region,
        formData.vpc_id,
        formData.subnets,
        formData.log_interval
    ])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{
                width: 600
              }}
            fullWidth={true}
            maxWidth = "sm"
        >
            <DialogTitle className={classes.dialogTitleBar}>{title}</DialogTitle>
            <DialogContent className={classes.dialog}>
                <DialogContentText component={'div'} className={classes.dialog}>
                    <Grid container spacing={2}>
                        <Grid item xs={11}>
                            <div style={{
                                width: '400px',
                                height: 0,
                                visibility: 'hidden',
                                overflow: 'hidden',
                                }}
                            />
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Name</InputLabel>
                        </Grid>
                        <Grid item xs={5}>
                            <ValidatedTextField
                                id='name'
                                name='pk'
                                label='Name*'
                                value={formData.pk}
                                onChange={handleChange}
                                variant={"outlined"}
                                classes={{ root: classes.whiteColor }}
                                sx={{
                                    width: 200
                                  }}
                                inputProps={{ style: { color: "#FFF" } }}
                                InputLabelProps={{ style: { color: "#AAA" } }}
                                error={error}
                                setError={setError}
                                mode='default-1'
                                required='required'
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Platform</InputLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <Select
                                required
                                name='platform'
                                label='OS'
                                defaultValue='Windows'
                                value={formData.platform}
                                onChange={handleChange}
                                disabled={false}
                                variant={"outlined"}
                                classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                  style={{minWidth: 125}}
                            >
                                {platform_type_menu.map((item) =>
                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                            </Select>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Site</InputLabel>
                        </Grid>
                        <Grid item xs={5} className={classes.inputRow}>
                            <Select
                                  name="site_uuid"
                                  label="Site"
                                  variant="outlined"
                                  value={formData.site_uuid}
                                  onChange={handleChange}
                                  classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                  style={{minWidth: 200}}
                                >
                                {siteData.map((formData) =>
                                    <MenuItem key={formData.pk} value={formData.pk}>{formData.site_name}</MenuItem>)}
                            </Select>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Install Type</InputLabel>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <Select
                                required
                                name='install_type'
                                label='Install Type'
                                defaultValue='Standalone'
                                value={formData.install_type}
                                onChange={handleChange}
                                disabled={installTypeDisabled}
                                variant={"outlined"}
                                classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                  style={{minWidth: 125}}
                            >
                                {install_type_menu.map((item) =>
                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                            </Select>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Policy</InputLabel>
                        </Grid>
                        <Grid item xs={5} className={classes.inputRow}>
                            <Select
                                name="policy_uuid"
                                label="Policy"
                                variant="outlined"
                                value={formData.policy_uuid}
                                onChange={handleChange}
                                classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                style={{ minWidth: 200 }}
                            >
                            {policyData.map((formData) =>
                                <MenuItem key={formData.pk} value={formData.pk}>{formData.policy_name}</MenuItem>)}
                            </Select>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Engine Size</InputLabel>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <Select
                                name='size'
                                label='Size'
                                value={formData.size}
                                onChange={handleChange}
                                variant={"outlined"}
                                //className={classes.dialog}
                                classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                  style={{minWidth: 125}}
                            >
                                {size_menu.map((item) =>
                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                            </Select>
                        </Grid>
                        {dynamic_fields()}
                        {environment_fields(formData.platform)}
                        {alerting_section()}
                        <Accordion className={classes.accordian}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1-content"
                              id="panel1-header"
                              sx={{ bgColor: "#555555" }}
                            >
                                Logging
                            </AccordionSummary>
                            <AccordionDetails className={classes.dialog}>
                                <Grid container spacing={2}>
                                    <Grid item xs={11}>
                                    <div style={{
                                            width: '400px',
                                            height: 0,
                                            visibility: 'hidden',
                                            overflow: 'hidden',
                                        }}
                                    />
                                </Grid>
                                    <Grid item xs={2}>
                                        <InputLabel className={classes.dialogWidget}>Log Level</InputLabel>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Select
                                            name="log_level"
                                            label="Log Level"
                                            variant="outlined"
                                            defaultValue={'WARN'}
                                            value={formData.log_level}
                                            onChange={handleChange}
                                            classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                            style={{ minWidth: 200 }}
                                        >
                                            {log_level_menu.map((item) =>
                                            <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={2} className={classes.inputRow}>
                                        <InputLabel className={classes.dialog}>Log Interval</InputLabel>
                                    </Grid>
                                    <Grid item xs={3} className={classes.inputRow}>
                                        <ValidatedTextField
                                            name='log_interval'
                                            label='Seconds*'
                                            value={formData.log_interval}
                                            onChange={handleChange}
                                            variant={"outlined"}
                                            //className={classes.dialog}
                                            classes={{ root: classes.whiteColor }}
                                            sx={{
                                                width: 100
                                              }}
                                            inputProps={{ style: { color: "#FFF" } }}
                                            InputLabelProps={{ style: { color: "#AAA" } }}
                                            error={error}
                                            setError={setError}
                                            mode='log-interval'
                                            required='required'
                                            maxLength={4}
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        <Grid container spacing={2}>
                        <Grid item xs={11}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>
                                Created: {formatDate(formData.created ? formData.created : new Date())}  ({getTimeDeltaHuman(formData.created ? formData.created : new Date())})
                            </Typography>
                        </Grid>
                        <Grid item xs={11}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>
                                Modified: {formatDate(formData.modified ? formData.modified : new Date())} ({getTimeDeltaHuman(formData.modified ? formData.modified : new Date())})
                            </Typography>
                        </Grid>
                        <Grid item xs={11}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>
                                Last Online: {formatDate(formData.seen )} ({getTimeDeltaHuman(formData.seen)})
                            </Typography>
                        </Grid>
                        <Grid item xs={11}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>
                                Used: {formData.ref_count ? formData.ref_count : 0}
                            </Typography>
                        </Grid>
                    </Grid>
                    </Grid>
                </DialogContentText>
                <DialogActions>
                    <Button className={classes.dialogNeutral} onClick={() => { setError([]); onClose()} } variant="contained" startIcon={<DisabledByDefaultOutlinedIcon />}>Close</Button>
                    <Button className={classes.dialogConfirm} onClick={(event) => handleSubmit(event)} variant="contained" startIcon={<CheckBoxOutlinedIcon />} disabled={getSaveButtonDisabled()}>SAVE</Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}
